import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {CompanyState}						from './interface';
import actions 								from './companyAction';


const initialState: CompanyState = {
	isLoad:         false,
	isLoadPut:      false,
	data:           null
};

export const getCompanyApi = createAsyncThunk('company/getCompanyApi', actions.getCompanyApi);
export const putCompanyApi = createAsyncThunk('company/putCompanyApi', actions.putCompanyApi);


export const Reducer = createSlice({
	name:          'company',
	initialState,
	reducers:      {},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getCompanyApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getCompanyApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload
			});
		})
		// --- PUT
		.addCase(putCompanyApi.pending, (state) => {
			state.isLoadPut = true;
		})
		.addCase(putCompanyApi.fulfilled, (state, action) => {
			return ({
				...state,
				data:      action.payload,
				isLoadPut: false
			});
		});
	}
});

// export const {logout} = Reducer.actions;

export default Reducer.reducer;
